<div class="flight_panel_container">
  @if (flightJourney) {
    <div class="flight-container" [ngClass]="{ 'upsell-wrapper': upsell }">
      <div
        class="flight-logo-container"
        [ngStyle]="{
          'border-right': upsell ? 'none' : 'auto'
        }"
      >
        @if (preferredMessages) {
          <app-preferred-icons
            class="icons-container"
            [tmcPreferred]="tmcPreferredLogoUrl"
            [tmcPreferredLogoUrl]="tmcPreferredLogoUrl"
            [tmcPreferredMessage]="preferredMessages[PreferredFlags.tmcPreferred]"
            [clientPreferred]="
              (preferred !== PreferredFlags.none && preferred !== PreferredFlags.tmcPreferred) ||
              preferenceLevel
            "
            [companyPreferredMessage]="preferredMessages[PreferredFlags.companyPreferred]"
            [officePreferredMessage]="preferredMessages[PreferredFlags.officePreferred]"
          >
          </app-preferred-icons>
        }
        <app-image-with-error
          title="{{ source }}"
          logoUrl="{{ logoUrl }}"
          [componentId]="'logo-' + flightJourney.operatingCarrierName"
          alt="{{ flightJourney.operatingCarrierName }} - {{ flightJourney.marketingCarrier }} {{
            flightJourney.marketingFlightNumber
          }} - {{ source }}"
          errorIcon="ico-flight"
          errorUrl=""
          class="ie-width-fix"
        >
        </app-image-with-error>
      </div>
      <div class="flight-description" [ngStyle]="{ 'border-right': upsell ? 'none' : 'auto' }">
        <div class="flight-airport-and-times">
          <div class="flight-airport">
            <span class="full-airport-name">{{ flightJourney.originAirportName }}</span>
            <span>({{ flightJourney.originAirport }})</span>
            @if (upsell) {
              <div>
                <ng-container *ngTemplateOutlet="flightTimeTemplate"></ng-container>
              </div>
            }
          </div>
          @if (!upsell) {
            <div>
              <ng-container *ngTemplateOutlet="flightTimeTemplate"></ng-container>
            </div>
          }
          <ng-template #flightTimeTemplate>
            <div class="flight-time">
              <time>{{ parseDateToMoment(flightJourney.dateTimeDeparting) | sabsTimePipe }}</time>
            </div>
          </ng-template>
          <div class="durationAndStops" [ngStyle]="{ width: upsell ? '50px' : 'auto' }">
            <div class="duration">
              @if (
                searchType !== FlightSearchType.multiCity &&
                !flightJourney.additional?.isExchangeMultiCityJourney
              ) {
                <time>{{ duration | sabsTimePipe: 'min_duration' }}</time>
              }
            </div>
            <div>
              @if (
                allJourneys.length === 1 ||
                (searchType === FlightSearchType.multiCity &&
                  displayType === FlightDisplayTypes.byPrice &&
                  allJourneys.length === search?.multiDestination.length) ||
                flightJourney.additional?.isExchangeMultiCityJourney
              ) {
                <span id="flight-header-stops" i18n="@@eurostarListDirect">Direct</span>
              } @else {
                <section class="container" (mouseleave)="layoverTt.close()">
                  <span
                    id="flight-header-stops"
                    [ngbTooltip]="layOverTooltip"
                    tooltipClass="layover_tooltip"
                    #layoverTt="ngbTooltip"
                    triggers="manual"
                    (mouseenter)="layoverTt.open()"
                    (focus)="layoverTt.open()"
                    (blur)="layoverTt.close()"
                    tabindex="0"
                  >
                    <ng-template #layOverTooltip>
                      @for (journey of allJourneys; track journey; let journeyIndex = $index) {
                        @if (allJourneys[journeyIndex + 1]; as nextJourney) {
                          <div class="flex-column-container">
                            @if (
                              showTimeDifference(
                                nextJourney.dateTimeDepartingUTC,
                                journey.dateTimeArrivingUTC
                              )
                            ) {
                              <div>
                                <div class="flex-row-container flex-row-container--between">
                                  <span>{{ journey.destinationAirport }}</span>
                                  <span class="layover_text"
                                    ><span i18n="@@flightHeaderLayover">Layover</span>:
                                    {{ timeDifference | sabsTimePipe: 'min_duration' }}</span
                                  >
                                </div>
                                <span>{{ journey.destinationAirportName }}</span>
                              </div>
                            }
                          </div>
                        }
                      }
                    </ng-template>
                    {{ getNumberOfStops() }} Stop
                    @if (shouldShowPlural()) {
                      <span>s</span>
                    }
                  </span>
                </section>
              }
            </div>
            <div class="marketing-carrier">
              @for (journey of allJourneys; track journey) {
                <div>{{ journey.marketingCarrier }}{{ journey.marketingFlightNumber }}</div>
              }
            </div>
          </div>
          @if (!upsell) {
            <div>
              <ng-container *ngTemplateOutlet="flightReturnTimeTemplate"></ng-container>
            </div>
          }
          <ng-template #flightReturnTimeTemplate>
            <div class="flight-time">
              <time>{{
                parseDateToMoment(lastFlightJourney.dateTimeArriving) | sabsTimePipe
              }}</time>
              <span class="day-difference">
                {{
                  searchType !== FlightSearchType.multiCity &&
                  !flightJourney.additional?.isExchangeMultiCityJourney
                    ? calculateDayDifference(
                        flightJourney.dateTimeDeparting,
                        lastFlightJourney.dateTimeArriving
                      )
                    : calculateDayDifference(
                        lastFlightJourney.dateTimeDeparting,
                        lastFlightJourney.dateTimeArriving
                      )
                }}
              </span>
            </div>
          </ng-template>
          <div class="flight-airport">
            <span class="full-airport-name">{{ lastFlightJourney.destinationAirportName }}</span>
            <span>({{ lastFlightJourney.destinationAirport }})</span>
            @if (upsell) {
              <div>
                <ng-container *ngTemplateOutlet="flightReturnTimeTemplate"></ng-container>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
</div>
